module.exports = __webpack_public_path__ + "img/recharge_img.53eb0818.png";